import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]

  toggle() {
    this.modalTarget.classList.toggle("chat-modal--open")
  }

  open() {
    this.modalTarget.classList.add("chat-modal--open")
  }

  close() {
    this.modalTarget.classList.remove("chat-modal--open")
  }
}
